import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { describeError } from '../errorHandlers/global.error-handler';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class VersionService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly loggerService = inject(LoggerService);
  private readonly swUpdate = inject(SwUpdate);

  readonly isNewVersionAvailable = signal(false);
  constructor() {
    const swUpdate = this.swUpdate;

    if (!this.swUpdate.isEnabled) {
      console.info('Service worker updates are disabled.');
      return;
    }
    console.info('Service worker updates are enabled.');
    swUpdate.versionUpdates.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event.type === 'VERSION_DETECTED') {
        this.isNewVersionAvailable.set(true);
      }
    });
  }
  applyUpdate(): void {
    // Reload the page to update to the latest version after the new version is activated
    this.swUpdate
      .activateUpdate()
      .then(() => document.location.reload())
      .catch(error => {
        console.error('Failed to apply updates:', error);
        this.loggerService.error(describeError(error), error?.stack);
      });
  }
}
